import { render, staticRenderFns } from "./accountManagement.vue?vue&type=template&id=c15cfb88&scoped=true"
import script from "./accountManagement.vue?vue&type=script&lang=js"
export * from "./accountManagement.vue?vue&type=script&lang=js"
import style0 from "./accountManagement.vue?vue&type=style&index=0&id=c15cfb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15cfb88",
  null
  
)

export default component.exports